<template>
  <div id="cyclic-list">
      <v-app id="inspire">
        <div>
          <v-data-table
            :headers="headers"
            :items="schemas"
            hide-actions
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td class="text-xs">{{ props.item.status | intToYesNo }}</td>
              <td class="text-xs">{{ props.item.confirmation | intToYesNo }}</td>

              <td class="justify-center layout px-0">
                <v-btn icon class="mx-0" @click="viewItem(props.item)">
                  <v-icon color="green darken-3">pageview</v-icon>
                </v-btn>
              </td>
            </template>
            <template slot="no-data">
              <v-btn color="primary" @click="loadCyclic">Reset</v-btn>
            </template>
          </v-data-table>
        </div>
      </v-app>
  </div>
</template>

<script>
import http from '@/plugins/http'

export default {
  components: {
  },
  data: () => ({
    headers: [
      {
        text: 'Nazwa',
        align: 'left',
        sortable: false,
        value: 'name'
      },
      { text: "Status", value:'status'},
      { text: "Potwierdzany", value:'confirmation'},

    ],
    schemas:[],
  }),
  created () {
    this.loadCyclic();
  },
  methods: {
    viewItem (item) {
      this.$router.push({'path':'/cycle/' + this.$route.params.cycleId +'/forms/'+item.id})
    },
    create(){
      this.$router.push({"path":"/cyclic"})
    },
    loadCyclic(){
      this.loading = true
      http.get('cycle/'+ this.$route.params.cycleId + '/schemas/all')
          .then(response => {
          this.schemas = response.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.link{
  text-decoration: none;
  color:black;
}
</style>
